import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "utils";

export const exportSample = createAsyncThunk('exportSample', async () => {

    try {
        const res = await axios({

            method: 'POST',
            url: getConfig.API_URL + 'onboarding_template',
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") },
            responseType: 'blob'

        })
        return res
    } catch (error) {
        return error.response
    }
})